import { Button, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import EditIcon from '@mui/icons-material/Edit'
import { XMarkSvg } from '../../../../common/svg/xMark'
import { CheckMarkSvg } from '../../../../common/svg/checkMark'
import { connect } from 'react-redux'
import { updateModal } from '../../../../../store/common/common_action'
import AutoTransactionModal from './AutoTransactionModal'
import * as mdt from '../../../../common/modaltypes'
import { focusElemnt, isEmpty, navigation1, navigation3, removeDuplicatesFromArray } from '../../../../common/helper'
import { getAutoBrnchTransRecvTblData, getAutoBrnchTransRecvFilters } from '../../../../../store/generalSetting/GSAction'
import moment from 'moment'
import SuccessAndErrorModal from '../../../../common/SuccessAndErrorModal'
import { getVehicleListV3 } from '../../../../../store/common/common_action'
const AutoBranchTransRecvTable = (props) => {
    const { data, updateModal, getAutoBrnchTransRecvTblData, getAutoBrnchTransRecvFilters, getVehicleListV3 } = props
    const { common, generalSettingReducer } = data
    const { loginData, roleRights, showModal, modalType, vehicleList } = common
    const { autoBrnchTransRecvTblData, autoBrnchTransRecvFilters } = generalSettingReducer
    const [tableData, setTableData] = useState([])
    const [editData, setEditData] = useState({})
    const [filterValues, setFilterValues] = useState({});
    const [filteredData, setfilteredData] = useState(tableData)
    const [cityList, setCityList] = useState([])
    const [branchList, setBranchList] = useState([])
    const [userList, setUserList] = useState([])
    const [vehicleListData, setVehicleListData] = useState([])
    const [isSuccess, setIsSuccess] = useState(false)
    const [message, setMessage] = useState('New Auto Receive Config.\n Saved Successfully!')
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    useEffect(() => {
        focusElemnt('abtCreateTrnsfrBtn')
    }, [])

    useEffect(() => {
        getTableData()
        getFilterData()
        getVehicleData()
    }, [loginData])
    const getTableData = () => {
        if (!isEmpty(loginData)) {
            let object = {
                TransID: 0,
                CompanyID: loginData?.intCompanyID,
                UserID: loginData?.intUserID,
            }
            getAutoBrnchTransRecvTblData(object, true, 24 * 60 * 60 * 1000)
        }
    }
    const getFilterData = () => {
        if (!isEmpty(loginData)) {
            let object = {
                CompanyID: loginData?.intCompanyID,
                CityID: 0,
                BranchID: 0,
                UserID: 0,
            }
            getAutoBrnchTransRecvFilters(object, true, 24 * 60 * 60 * 1000)
        }
    }
    const getVehicleData = () => {
        if (!isEmpty(loginData)) {
            let object = {
                intCompanyID: loginData?.intCompanyID,
                intFromCityID: 0,
                intToCityID: 0,
                dtJdate: moment(new Date()),
                intMode: 1,
                intFromBranchID: 0
            }
            getVehicleListV3(object, true, 24 * 60 * 60 * 1000)
        }
    }
    useEffect(() => {
        if (autoBrnchTransRecvTblData?.length > 0) {
            const data = [...autoBrnchTransRecvTblData]
            data.sort((a, b) => {
                const cityComparison = a.FromCity.localeCompare(b.FromCity);
                if (cityComparison !== 0) {
                    return cityComparison;
                }
                return a.FromBranch.localeCompare(b.FromBranch);
            });
            setTableData(data)
        } else {
            setTableData([])
        }
    }, [autoBrnchTransRecvTblData])
    useEffect(() => {
        if (autoBrnchTransRecvFilters?.length > 0) {
            var cities = []
            autoBrnchTransRecvFilters.map(function (obj) {
                cities.push({
                    id: obj.CityID,
                    name: obj.CityName
                })
            })
            cities = removeDuplicatesFromArray(cities, `id`)
            cities.sort((a, b) => {
                return a.name.localeCompare(b.name);
            });
            setCityList(cities)
            var branches = []
            autoBrnchTransRecvFilters.map(function (obj) {
                branches.push({
                    id: obj.BranchID,
                    name: obj.BranchName,
                    city: obj.CityID
                })
            })
            branches = removeDuplicatesFromArray(branches, `id`)
            branches.sort((a, b) => {
                return a.name.localeCompare(b.name);
            });
            setBranchList(branches)
            var users = []
            autoBrnchTransRecvFilters.map(function (obj) {
                users.push({
                    id: obj.UserID,
                    name: obj.UserName,
                    branch: obj.BranchID
                })
            })
            users = removeDuplicatesFromArray(users, `id`)
            users.sort((a, b) => {
                return a.name.localeCompare(b.name);
            });
            setUserList(users)
        }
    }, [autoBrnchTransRecvFilters])

    useEffect(() => {
        if (vehicleList?.length > 0) {
            var vehicles = []
            vehicleList.map(function (obj) {
                vehicles.push({
                    id: obj.VehicleID,
                    name: obj.VehicleNo,
                })
            })
            vehicles = removeDuplicatesFromArray(vehicles, `id`)
            vehicles.sort((a, b) => {
                return a.name.localeCompare(b.name);
            });
            setVehicleListData(vehicles)
        }
    }, [vehicleList])
    useEffect(() => setfilteredData(tableData), [tableData])

    useEffect(() => {
        const filteredDataTemp = tableData.filter((item) => {
            return columnDefs.every((column) => {
                const filterValue = filterValues[column.field] || "";
                const value = item[column.field]?.toString()
                return filterValue ? value && value.toString().toLowerCase().includes(filterValue.toLowerCase()) : true
            })
        })
        setfilteredData(filteredDataTemp)
    }, [filterValues])
    const handleChangeContain = (e, name) => {
        let value = e.target.value;
        setFilterValues((prevFilterValues) => ({
            ...prevFilterValues,
            [name]: value
        }));
    }
    const columnDefs = [
        { headerName: 'SN', headerSx: { padding: "6px 12px", textAlign: 'right', minWidth: "4%" }, field: "SN", dataType: "number", showfilter: false, allowSorting: false },
        { headerName: 'Branch Transfer\n From City', headerSx: { padding: "6px 12px", textAlign: 'left', minWidth: "9%" }, field: "FromCity", dataType: "string", showfilter: true, allowSorting: false },
        { headerName: 'Branch Transfer\n From Branch', headerSx: { padding: "6px 12px", textAlign: 'left', minWidth: "12%" }, field: "FromBranch", dataType: "string", showfilter: true, allowSorting: false },
        { headerName: 'Branch Transfer\n From User', headerSx: { padding: "6px 12px", textAlign: 'left', minWidth: "9%" }, field: "FromUser", dataType: "string", showfilter: true, allowSorting: false },
        { headerName: 'Branch Transfer\n Receive By City', headerSx: { padding: "6px 12px", textAlign: 'left', minWidth: "9%" }, field: "ToCity", dataType: "string", showfilter: true, allowSorting: false },
        { headerName: 'Branch Transfer\n Receive By Branch', headerSx: { padding: "6px 12px", textAlign: 'left', minWidth: "12%" }, field: "ToBranch", dataType: "string", showfilter: true, allowSorting: false },
        { headerName: 'Branch Transfer\n Receive By User', headerSx: { padding: "6px 12px", textAlign: 'left', minWidth: "9%" }, field: "ToUser", dataType: "string", showfilter: true, allowSorting: false },
        { headerName: 'Vehicle Number\nBranch Transfer', headerSx: { padding: "6px 12px", textAlign: 'left', minWidth: "9%" }, field: "VehicleNo", dataType: "string", showfilter: true, allowSorting: false },
        { headerName: 'Status', headerSx: { padding: "6px 12px", textAlign: 'center', minWidth: "5%" }, field: "Active", dataType: "string", showfilter: false, allowSorting: false },
        { headerName: 'Modified By\n User', headerSx: { padding: "6px 12px", textAlign: 'left', minWidth: "9%" }, field: "ModUser", dataType: "string", showfilter: true, allowSorting: false },
        { headerName: 'Modified Date\n and Time', headerSx: { padding: "6px 12px", textAlign: 'left', minWidth: "9%" }, field: "ModifiedDateTime", dataType: "time", showfilter: false, allowSorting: false },
        { headerName: 'Edit', headerSx: { padding: "6px 12px", textAlign: 'left', minWidth: "4%" }, field: "Edit", dataType: "string", showfilter: false, allowSorting: false },
    ]

    const showAutoTransRecvModal = () => {
        const dataValues = {
            editData: {},
            isEdit: false,
            mdt: mdt,
            headerText: 'Create Auto Branch Transfer & Branch Receive Configuration',
            cityList: cityList,
            branchList: branchList,
            userList: userList,
            vehicleListData: vehicleListData,
            tableData: tableData,
            setIsSuccess: setIsSuccess,
            setMessage: setMessage,
            getTableData: getTableData,
        }
        return <AutoTransactionModal dataValues={dataValues} updateModal={updateModal} />
    }
    const showUpdateAutoTransRecvModal = () => {
        const dataValues = {
            editData: editData,
            isEdit: true,
            mdt: mdt,
            headerText: 'Edit Auto Branch Transfer & Branch Receive Configuration',
            cityList: cityList,
            branchList: branchList,
            userList: userList,
            vehicleListData: vehicleListData,
            tableData: tableData,
            setIsSuccess: setIsSuccess,
            setMessage: setMessage,
            getTableData: getTableData
        }
        return <AutoTransactionModal dataValues={dataValues} updateModal={updateModal} />
    }

    const EmptyTableRow = () => {
        return (
            <TableRow>
                <TableCell colSpan={12}>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '15px',
                            marginBottom: '15px',
                            color: 'red',
                            fontSize: '14px',
                        }}
                    >
                        <span>No results found for the selected filters.</span>
                    </div>
                </TableCell>
            </TableRow>
        )
    }
    const AutoTransRecvRow = (props) => {
        const { item, index } = props
        return (
            <TableRow key={`auto-trans-recv-${index}`} style={{ minHeight: '36px' }}>
                <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '4%', padding: '4px 8px', textAlign: 'right' }}> {index + 1} </TableCell>
                <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '9%', padding: '4px 8px', maxWidth: '120px' }}>
                    <Tooltip title={`${item.FromCity}`}
                        PopperProps={{
                            sx: {
                                "& .MuiTooltip-tooltip": {
                                    backgroundColor: '#DAEDFE',
                                    color: "#000",
                                    minHeight: '26px',
                                    display: 'flex',
                                    fontWeight: '400',
                                    alignItems: "center",
                                    marginTop: '5px !important',
                                    fontSize: '12px'
                                }
                            }
                        }}
                        placement="bottom-start">
                        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer', textDecoration: 'underline' }}>
                            {item.FromCity}
                        </span>
                    </Tooltip>
                </TableCell>
                <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '12%', padding: '4px 8px', maxWidth: '160px' }}>
                    <Tooltip title={`${item.FromBranch}`}
                        PopperProps={{
                            sx: {
                                "& .MuiTooltip-tooltip": {
                                    backgroundColor: '#DAEDFE',
                                    color: "#000",
                                    minHeight: '26px',
                                    display: 'flex',
                                    fontWeight: '400',
                                    alignItems: "center",
                                    marginTop: '5px !important',
                                    fontSize: '12px'
                                }
                            }
                        }}
                        placement="bottom-start">
                        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer', textDecoration: 'underline' }}>
                            {item.FromBranch}
                        </span>
                    </Tooltip>
                </TableCell>
                <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '9%', padding: '4px 8px', maxWidth: '120px' }}>
                    <Tooltip title={`${item.FromUser}`}
                        PopperProps={{
                            sx: {
                                "& .MuiTooltip-tooltip": {
                                    backgroundColor: '#DAEDFE',
                                    color: "#000",
                                    minHeight: '26px',
                                    display: 'flex',
                                    fontWeight: '400',
                                    alignItems: "center",
                                    marginTop: '5px !important',
                                    fontSize: '12px'
                                }
                            }
                        }}
                        placement="bottom-start">
                        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer', textDecoration: 'underline' }}>
                            {item.FromUser}
                        </span>
                    </Tooltip>
                </TableCell>
                <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '9%', padding: '4px 8px', maxWidth: '120px' }}>
                    <Tooltip title={`${item.ToCity}`}
                        PopperProps={{
                            sx: {
                                "& .MuiTooltip-tooltip": {
                                    backgroundColor: '#DAEDFE',
                                    color: "#000",
                                    minHeight: '26px',
                                    display: 'flex',
                                    fontWeight: '400',
                                    alignItems: "center",
                                    marginTop: '5px !important',
                                    fontSize: '12px'
                                }
                            }
                        }}
                        placement="bottom-start">
                        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer', textDecoration: 'underline' }}>
                            {item.ToCity}
                        </span>
                    </Tooltip>
                </TableCell>
                <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '12%', padding: '4px 8px', maxWidth: '160px' }}>
                    <Tooltip title={`${item.ToBranch}`}
                        PopperProps={{
                            sx: {
                                "& .MuiTooltip-tooltip": {
                                    backgroundColor: '#DAEDFE',
                                    color: "#000",
                                    minHeight: '26px',
                                    display: 'flex',
                                    fontWeight: '400',
                                    alignItems: "center",
                                    marginTop: '5px !important',
                                    fontSize: '12px'
                                }
                            }
                        }}
                        placement="bottom-start">
                        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer', textDecoration: 'underline' }}>
                            {item.ToBranch}
                        </span>
                    </Tooltip>
                </TableCell>
                <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '9%', padding: '4px 8px', maxWidth: '120px' }}>
                    <Tooltip title={`${item.ToUser}`}
                        PopperProps={{
                            sx: {
                                "& .MuiTooltip-tooltip": {
                                    backgroundColor: '#DAEDFE',
                                    color: "#000",
                                    minHeight: '26px',
                                    display: 'flex',
                                    fontWeight: '400',
                                    alignItems: "center",
                                    marginTop: '5px !important',
                                    fontSize: '12px'
                                }
                            }
                        }}
                        placement="bottom-start">
                        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer', textDecoration: 'underline' }}>
                            {item.ToUser}
                        </span>
                    </Tooltip>
                </TableCell>
                <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '9%', padding: '4px 8px' }}> {item.VehicleNo} </TableCell>
                <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '5%', padding: '4px 8px', textAlign: 'center' }}>
                    {item.IsActive ?
                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                            <CheckMarkSvg />
                        </span> :
                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                            <XMarkSvg />
                        </span>}
                </TableCell>
                <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '9%', padding: '4px 8px', maxWidth: '120px' }}>
                    <Tooltip title={`${item.ModUser}, ${item.ModifiedUserBranch}`}
                        PopperProps={{
                            sx: {
                                "& .MuiTooltip-tooltip": {
                                    backgroundColor: '#DAEDFE',
                                    color: "#000",
                                    minHeight: '26px',
                                    display: 'flex',
                                    fontWeight: '400',
                                    alignItems: "center",
                                    marginTop: '5px !important',
                                    fontSize: '12px'
                                }
                            }
                        }}
                        placement="bottom-start">
                        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer', textDecoration: 'underline' }}>
                            {item.ModUser}
                        </span>
                    </Tooltip>
                </TableCell>
                <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '9%', padding: '4px 8px' }}> {moment(item.ModifiedDateTime).format("HH:mm, DD-MMM-YY")} </TableCell>
                <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '4%', padding: '4px 8px' }}>
                    <span id={`editBtn-${index}`} tabIndex={0} style={{ display: 'flex', color: '#007bfd', fontSize: '13px', fontWeight: 'bold', width: '52px', padding: '2px 4px', marginLeft: '-6px' }}
                        onClick={() => {
                            setEditData(item)
                            updateModal(true, mdt.UpdateAutoBrnchTransRecvModal)
                        }}
                        onKeyDown={(e) => {
                            navigation3(e, index === tableData?.length - 1 ? 'abtCreateTrnsfrBtn' : `editBtn-${index + 1}`, index === 0 ? 'abtCreateTrnsfrBtn' : `editBtn-${index - 1}`, () => {
                                setEditData(item)
                                updateModal(true, mdt.UpdateAutoBrnchTransRecvModal)
                            })
                        }}
                    >
                        <EditIcon sx={{ marginRight: '3px' }} />
                        Edit
                    </span>
                </TableCell>
            </TableRow>
        )
    }
    return (
        <>
            <Stack style={{ padding: '11px 0px' }}>
                <Button
                    id="abtCreateTrnsfrBtn"
                    style={{ margin: '0', height: "40px", width: '265px' }}
                    className="btn add-btn"
                    variant="contained"
                    color="error"
                    onClick={() => {
                        updateModal(true, mdt.AutoBrnchTransRecvModal)
                    }}
                    onKeyDown={(e) => navigation1(e, `editBtn-0`, `editBtn-${tableData?.length - 1}`)}

                >
                    + create new Transfer
                </Button></Stack>
            <Stack style={{ maxHeight: '60vh', marginTop: '7px' }}>
                <TableContainer className="lr-popup-table lrModel  scrollBlue" style={{ border: '1px solid #ddd', borderBottomLeftRadius: '0px' }} component={Paper}>
                    <Table style={{ border: "none", overflow: 'auto' }} stickyHeader id="focApprovalTbl" className="table1 table-Received " size="small" aria-label="a dense table">
                        <TableHead style={{ position: `sticky`, top: `0`, background: `white`, zIndex: '2' }}>
                            <TableRow key='ABT-tbl-header' style={{ background: '#d9edff' }}>
                                {columnDefs.map((col, index) =>
                                    <TableCell key={`ABT-TH-${index}`} style={{ ...col.headerSx, verticalAlign: 'top', padding: '4px 8px', backgroundColor: '#DAEDFE', minHeight: '36px', fontFamily: 'Roboto', fontSize: '12px', fontWeight: '600', color: '#444444' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: "space-between" }}>
                                            {col.headerName.split('\n').map((line, lineIndex) => (
                                                <span key={`line-${lineIndex}`} style={{}}>{line}</span>
                                            ))}

                                        </div>
                                    </TableCell>
                                )}
                            </TableRow>
                            <TableRow>
                                {columnDefs.map((col, index) => col.showfilter ?
                                    <TableCell key={`FTH-${index}`} style={{ padding: '6px 6px' }}>
                                        <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                                            <input
                                                id={`contains-${index}`}
                                                className="field"
                                                name="cancelSearchInput"
                                                style={{ width: '100%', paddingTop: '6px', paddingBottom: '6px', height: '24px' }}
                                                placeholder="Contains"
                                                onChange={(e) => handleChangeContain(e, col.field)}
                                                onKeyDown={(e) => navigation1(e, index === 9 ? `contains-1` : index === 7 ? `contains-9` : `contains-${index + 1}`, index === 1 ? `contains-9` : index === 9 || index === 8 ? `contains-7` : `contains-${index - 1}`)}
                                            />
                                            <FilterAltIcon style={{ color: '#AAA' }} />
                                        </div>
                                    </TableCell>
                                    : <TableCell key={`auto-tr-emptycell-${index}`}></TableCell>)}
                            </TableRow>
                        </TableHead>
                        {
                            filteredData?.length > 0 ?
                                <>
                                    <TableBody className="filter-data-row" style={{ border: "none" }}>
                                        {filteredData?.map((item, index) => (
                                            <AutoTransRecvRow item={item} index={index} key={index} />
                                        ))}
                                    </TableBody>
                                </> :
                                <>
                                    <TableBody>
                                        <EmptyTableRow />
                                    </TableBody>
                                </>
                        }
                    </Table>
                </TableContainer>
            </Stack>
            {showModal && mdt.AutoBrnchTransRecvModal === modalType ? showAutoTransRecvModal() : null}
            {showModal && mdt.UpdateAutoBrnchTransRecvModal === modalType ? showUpdateAutoTransRecvModal() : null}
            <SuccessAndErrorModal handleClose={() => { setIsSuccess(false); }} open={isSuccess} title={message} modalStyle={modalStyle} />

        </>
    )
}

const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
    updateModal, getAutoBrnchTransRecvTblData, getAutoBrnchTransRecvFilters, getVehicleListV3
}
export default connect(mapStateToProps, mapDispatchToProps)(AutoBranchTransRecvTable)
